export enum QuoteStatusEnum {
  NO_QUOTES = 'NO_QUOTES',
  CREATED = 'CREATED',
  QUOTE_IN_PROGRESS = 'QUOTE_IN_PROGRESS',
  ABANDONED = 'ABANDONED',
  FINISHED = 'FINISHED',
}
